import React, {useLayoutEffect, useRef, useEffect, useContext, useState} from 'react'
import UserContext from '../context/UserContext'
import DictionaryContext from '../context/DictionaryContext'
import FormFields from './FormFields'
import Form from 'react-bootstrap/Form'
import Select from 'react-select'
// import AsyncSelect from 'react-select/async'

import styles from './InventoryForm.module.css'

import { Button, Row, Col } from 'react-bootstrap'
import ConfirmDialog from './ConfirmDialog'
import {BsFillSignStopFill, BsExclamationCircle, BsInfoCircle} from 'react-icons/bs'
import moment from 'moment'
import InventoryImages from './InventoryImages'
import { trackPromise } from 'react-promise-tracker'
import LoadingSpinner from './LoadingSpinner'
import AuditList from './AuditList'
import useDeviceChanged from '../hooks/useDeviceChanged';

// props: id (inventory id)
function InventoryForm(props) {
    const userCtx = useContext(UserContext)
    const dictCtx = useContext(DictionaryContext)
    // const {setDeviceChanged, resetDeviceChanged} = useDeviceChanged((state) => {
    //   return {setDeviceChanged: state.setChanged, resetDeviceChanged: state.resetChanged};
    // });
    const setDeviceChanged = useDeviceChanged((state) => state.setChanged);

    const reqOnsiteValidation = 'request_onsite_encryption_validation'

    const fields = FormFields()
    const scrollable = useRef()


    const requiredGroupsTexts = () => {
        const groupped_fields = fields.filter(f => !!f.required_group)//.sort((f1, f2) => +f2.required_group - +f1.required_group)

        const groupedByGroupId = groupped_fields.reduce((acc, field) => {
            const key = field.required_group;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(field.display_name);
            return acc;
        }, {});

        // console.log("groupedByGroupId", groupedByGroupId)

        return Object.keys(groupedByGroupId).map(group_id => {
            return {gid: group_id, text: `At least one of the ${groupedByGroupId[group_id].join(', ').replace(/,(?=[^,]*$)/, " or")} fields is required`}
        })

    }

    const requiredGroupsNotes = requiredGroupsTexts()

    // const { promiseInProgress } = usePromiseTracker();

    // used to get values of all html elements except of dropdowns (Select from react-select)
    const inputRefs = useRef({});
    const refAudit = useRef();

    // const uploadFileRef = useRef()

    // used for values from react-select
    const [dropdowns, setDropdowns] = useState([])

    const [item, setItem] = useState(null)
    // const [showConfirm, setShowConfirm] = useState(false)
    // const [confirmOnly, setConfirmOnly] = useState(false)


    const [confirmDialogParams, setConfirmDialogParams] = useState({show: false})

    const [files, setFiles] = useState([])
    const [images, setImages] = useState([])
    const [errors, setErrors] = useState({})
    const [recerts, setRecerts] = useState(null)
    const [recertsStatus, setRecertsStatus] = useState({text: '', style: '', text_style: '', button: "Device can't be certified until saved", disabled: true})
    const [audits, setAudits] = useState([])
    const [initialLoadFinished, setInitialLoadFinished] = useState(false);
    
    const [attestationStatus, setAttestationStatus] = useState(null)


    const errorBorderColor = 'red'
    const normalBorderColor = 'hsl(0, 0%, 80%)'

    const [reactSelectBorderColor, setReactSelectBorderColor] = useState({})

    const thumb_url_base = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}inventory_images/thumbimage/` : `${process.env.REACT_APP_API_URL_PROD}inventory_images/thumbimage/`
    const baseURL = process.env.REACT_APP_MODE === "TEST" ? process.env.REACT_APP_API_URL_TEST : process.env.REACT_APP_API_URL_PROD
    const uploadImageURL = (inventory_id) => `${baseURL}inventory_images/?invntry_id=${inventory_id}`
    const deleteImageURL = (imageId) => `${baseURL}inventory_images/${imageId}`
    const getInventoryRecertsURL = (inventory_id) => `${baseURL}inventory_recerts/invntry/${inventory_id}`
    const createInventoryRecertsURL = `${baseURL}inventory_recerts/`
    const getAuditURL = (inventory_id) => `${baseURL}audit_records/invntry/${inventory_id}`



    const isRequestOnsiteValidationDisabled = () => {
        // special processing for device types that require images or on-site validation
        // if the value selected from device type drop down doesn't require on-site validation or images then re-set checkbox and disable it
        // otherwise enable it
        const dev_type_field = fields.find(f => f.name === 'device_type') 
        // console.log("item", item)
        const dev_type_value = item['device_type']
        const requires_image = dictCtx.dict_device_type
            .find(dt => dt.system_name === dev_type_field.dictionary && dt.dictionary_value === dev_type_value)?.requires_image

        // console.log("Device Type", dev_type_value)
        // console.log("requires_image", requires_image)

        if (!!!requires_image) {
            // reset checkbox and disable
            // console.log("inputRefs.current[field2.name]", inputRefs.current[field2.name])
            // inputRefs.current[reqOnsiteValidation].checked = false
            // inputRefs.current[reqOnsiteValidation].disabled = true
            return true
        } else {
            // enable checkbox
            // inputRefs.current[reqOnsiteValidation].disabled = false
            return false
        }


    }


    // dropdown selected value
    const onSelect = (name, e) => {
        let bcolors = reactSelectBorderColor
        Object.keys(bcolors).forEach(k => bcolors[k] = normalBorderColor)
        // console.log('bcolors', bcolors)
        setReactSelectBorderColor(bcolors)


        setErrors({...errors, [name]:null})
        // console.log("selected", name, e, e.value)
        setItem({...item, [name]: !!e? e.value : ''})
        setDeviceChanged(true);
        let dVals = [...dropdowns]
        let indx = dVals.findIndex(d => d.name === name)
        let field = fields.find(f => f.name === name)

        dVals[indx] = {...dVals[indx], option: {label: !!e ? e.label : '', value: !!e ? e.value : field.null_value}}


        // special processing for dropdowns with dependants - field has property dependant; clearing that field should clear dependant value as well
        // if a value selected then depandant dropdown should be populated with corresponding values
        
        if (!!field.dependant) {
            // there is a dependant - clear the values
            const field2 = fields.find(f => f.name === field.dependant)
            indx = dVals.findIndex(d => d.name === field.dependant)

            // console.log("onSelect: field2, indx, dVals[indx]", field2, indx, dVals[indx])
            if (field2.type === 'dictionary') {
                dVals[indx] = {...dVals[indx], option: {label: '', value: field2.null_value}}
            } else if (field2.type === 'checkbox') {
                if (field2.name === reqOnsiteValidation) {
                    // special processing for device types that require images or on-site validation
                    // if the value selected from device type drop down doesn't require on-site validation or images then re-set checkbox and disable it
                    // otherwise enable it
                    if (!!e && !!e.value) {
                        const requires_image = dictCtx.dict_device_type
                            .find(dt => dt.system_name === field.dictionary && dt.dictionary_value === e.value)?.requires_image
                        if (!!!requires_image) {
                            // reset checkbox and disable
                            // console.log("inputRefs.current[field2.name]", inputRefs.current[field2.name])
                            inputRefs.current[field2.name].checked = false
                            inputRefs.current[field2.name].disabled = true
                        } else {
                            // enable checkbox if there are no images
                            inputRefs.current[field2.name].disabled = false
                        }
                    }
                } else if (!!e && !!e.value) {
                    dVals[indx] = {...dVals[indx], option: {label: '', value: field2.checked}}
                }
            }
            
        }
        
        // console.log("new values of dropdowns", dVals)
        setDropdowns([...dVals])
    } 

    const updateInventoryItem = async (item, item_id) => {

        // files may have list of image files to upload
        // images may have images mark to be deleted
        // upload new images
        // console.log("images to upload", files)
        if (files.length > 0) {
            // addImagesToInventory(true)
            addImagesToInventory(false)
        } 

        const images_to_delete = images.filter(img => !!img.markToDelete)
        images_to_delete.forEach(img => deleteImage(img))


        // update the inventory item if necessary

        const url = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}inventories` : `${process.env.REACT_APP_API_URL_PROD}inventories`

        // console.log("item, files", item, files)

        const jsonData = JSON.stringify(item)

        if (Object.keys(item).length > 0) {
            await fetch(`${url}/${item_id}`, {
                method: 'PATCH',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    'Content-Type': 'application/json'
                },
                body: jsonData
                    
                
            })
            .then((response) => response.json())
            .then(data => {
                // console.log("inventory updated", data)
                // props.onClose(true)
            })
            .catch(e => console.log("error saving  item", e))
        } else {
            // nothing to update - close the item
            // props.onClose(true)
        }
        
    }




    const createInventoryItem = async (item) => {
        const url = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}inventories/` : `${process.env.REACT_APP_API_URL_PROD}inventories/`
        const jsonData = JSON.stringify(item)
        const fdata = new FormData()

        fdata.append('inventory_in', jsonData)

        // console.log("createInventoryItem - files", files)
        if (!!files && files.length > 0) {
            files.forEach((val, index) => {
                fdata.append("files", files[index]);
            })
        }

        await fetch(`${url}`, {
            method: 'POST',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                Accept: 'application/json'
                // 'Content-Type': 'multipart/form-data'
            },
            body: fdata
        })
        .then((response) => response.json())
        .then(data => {
            // console.log("inventory created", data)
            setFiles([])
            // delete no-inventory record (if exists)
            console.log("Delete no inventory")
            props.deleteNoInventory()
            // close the form and refresh item list
            // props.onClose(true)
        })
        .catch(e => {
            console.log("error saving  item", e)
            setConfirmDialogParams({
                show: true,
                text: ['Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                prompt: 'Unexpected error happened while trying to save the item', 
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        })
    }



    const deleteImage = async (image) => {
        // console.log("Deleting image", image)
        try {            
            let httpMethod = "DELETE"
            const url=deleteImageURL(image.id)
                   
            const response = await fetch(url, {
                method: httpMethod,
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`
                }
            })

            if (response.status === 200) {
                const responseData = await response.json()
                // console.log("image deleted", responseData)

                // remove image from image array

            } else {
                console.log("Failed to delete image", response)
            }
        } catch (e) {
            console.log("Failed to delete image", e)
        }

    
    }


    const formatRecerts = (recerts_data) => {
        setRecerts(recerts_data)
        let by_who_and_when = ''
        // if (!!recerts_data.final_validation_by) {
        //     by_who_and_when = ` by ${recerts_data.final_validation_by} on ${formatDateTime(recerts_data.final_validation_date).replace('T',' at ')}`
        // } else 
        if (recerts_data.initial_validation_by) {
            by_who_and_when = ` by ${recerts_data.initial_validation_by} on ${formatDateTime(recerts_data.initial_validation_date).replace('T',' at ')}`
        }
        // 2025-08-07: Getting rid of Final certification. Replace "Initial certification" with just "certification" 
        setRecertsStatus({
          text: `Certified ${by_who_and_when}.`, 
          style: 'item-final-certified', 
          text_style: 'final-certified-text', 
          button: 'Device Certified', 
          disabled: true
        }) 

        // setRecertsStatus(!!recerts_data.final_validation_by ? 
        //     {text: `Finally Certified ${by_who_and_when}.`, style: 'item-final-certified', text_style: 'final-certified-text', button: 'Device Certified', disabled: true} 
        //     : 
        //     {text: `Initially Certified ${by_who_and_when}.`, style: 'item-init-certified', text_style: 'init-certified-text', button: 'Final Certify Device', disabled: false})
    }

    const createInventoryRecerts = async (recert_data) => {
        let url = '';
        let method = '';
        // method and URL depend on the initial/final validation
        if (!!recert_data.initial_validation_by) {
            url = createInventoryRecertsURL;
            method = "POST";
        }
        // if (!!recert_data.final_validation_by) {
        //     url = `${createInventoryRecertsURL}by_inventory_id/${recert_data.inventory_id}`;
        //     method = "PATCH";
        // }
        await fetch(url, {
            method: method,
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(recert_data)
        })
        .then((response) => response.json())
        .then(data => {
            // console.log("certification created", data)
            formatRecerts(data)
            // setFiles([])
            // // close the form and refresh item list
            // props.onClose(true)
        })
        .catch(e => {
            console.log("error creating certification", e)
            setConfirmDialogParams({
                show: true,
                text: ['Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                prompt: 'Unexpected error happened while certfying the item', 
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        })
    }


    const getInventoryRecerts = async (id) => {
        if (!!id) {
            await fetch(getInventoryRecertsURL(id), {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    Accept: 'application/json'
                },
            })
            .then((response) => response.json())
            .then(data => {
                // console.log("recerts", data)
                // make sure the certification date is AFTER the certification start date
                if (!!data && !!data.id && !!data.initial_validation_by && new Date(data.initial_validation_date) >= new Date(dictCtx.dict_certification_start_date)) {
                    formatRecerts(data)
                } else {
                    // no recerts really
                    setRecerts(null)
                    // as of 2025-08-07 - there will be only one certification, so Initial Certification will be Certification and no Final Certification anymore
                    setRecertsStatus({text: 'Not Certfied.', style: 'item-uncertified', text_style: 'uncertified-text', button: 'Certify Device', disabled: false})
                    // setRecertsStatus({text: 'Not Certfied.', style: 'item-uncertified', text_style: 'uncertified-text', button: 'Initially Certify Device', disabled: false})
                }
            })
            .catch(e => {
                console.log("error gettign recerts  item", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    prompt: 'Unexpected error happened while trying to access certifications',
                    prompt_class: 'alert-prompt-red',
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })

        }
        



    }



    const certifyItemClick = () => {
        if (didFormValuesChange()) {
            // some values changed - need to save changes before certification
            setConfirmDialogParams({
                show: true,
                text: ["There are unsaved changes.", 'Please save before certifcation.'],
                textClass: 'confirmation-text',
                prompt_class: 'alert-prompt-black',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => {
                    setConfirmDialogParams({show: false})
                },
                title: 'Attention',
                title_class: 'alert-title-black',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
            // setConfirmOnly(true)
        } else {
            // create certification
            // 1. read existing certification
            // 2. if not found then create initial cert
            // if initial cert exists create final cert
            // getInventoryRecerts(item.id)
            // if (props.item.)
            let resert_data = {}
            if (recerts === null) {
                // do initial certification
                resert_data = {
                    inventory_id: item.id,
                    added_by_userid: userCtx.user_name,
                    initial_validation_by: userCtx.user_name,
                    initial_validation_date: new Date().toISOString()
                }
                createInventoryRecerts(resert_data)
            // } else if (recerts.final_validation_date === null) {
            //     // do final validation
            //     resert_data = {
            //         inventory_id: item.id,
            //         added_by_userid: userCtx.user_name,
            //         final_validation_by: userCtx.user_name,
            //         final_validation_date: new Date().toISOString()
            //     }
            //     createInventoryRecerts(resert_data)
            } else {
                // already validated
                setConfirmDialogParams({
                    show: true,
                    text: ["The inventory item is already validated."],
                    textClass: 'confirmation-text',
                    prompt_class: 'alert-prompt-black',
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => {
                        setConfirmDialogParams({show: false})
                    } ,
                    title: 'Attention',
                    title_class: 'alert-title-black',
                    icon: <BsInfoCircle />,
                    confirm_only: true,
                })
                // setConfirmOnly(true)

            }

        }
    }



    const areValuesTheSame = (val1, val2, value_type) => {

        // special treatment for date/time
        if ((value_type === 'date' || value_type == 'datetime-local') ) {

            const date1 = moment(val1)
            const date2 = moment(val2)

            if (date1 !== date2) {
                return false
            } else {
                return true
            }

        }
            
        // for text consider blanks and null the same
        if (value_type === 'text' || value_type === 'textarea') {
            
            const txval1 = !!val1 ? val1.trim() : ''
            const txval2 = !!val2 ? val2.trim() : ''   
            
            if (txval1 !== txval2) {
                return false
            } else {
                return true
            }
        }

        if (value_type === 'checkbox') {
            return !!val1 == !!val2
        }


        if (!!val1 !== !!val2) {
            return false
        }
            
        // special case comparing undefined (for new item) with something else
        if (val1 === undefined && !!!val2) {
            return true
        }
            
        if (!!!val1 && val2 === undefined) {
            return true
        }

        if (val1 != val2) {
            return false
        }
            
        return true
    }


    const didFormValuesChange = () => {
        const changed_values = {}
        Object.keys(inputRefs.current).forEach(k => {
            // if updating existing item, include only properties that changed

            // for dictionary values (SELECT) get value from the state
            const field = fields.find(f => f.name === k)
            let value = null
            switch(field.type) {
                case 'dictionary':
                    value = dropdowns.find(d => d.name === k).option.value
                    break;
                case 'checkbox':
                    value = inputRefs.current[k].checked
                    // console.log("Checkbox checked", value)
                    break;
                default:
                    value = inputRefs.current[k].value
                    break
            }


            // special treatment for datetime. Original values (in props.item) are UTC date/time
            // datepicker date/time are local time
            // before comparing them we need to bring them to the same time zone

            if (field.type === 'datetime-local' || field.type === 'date') {
                if (!areValuesTheSame(moment.utc(props.item[k]).startOf('minute'), value, field.type)) {
                    changed_values[k] = value
                }
            }

            if (field.type === 'checkbox') {
                // console.log("Compare checkbox values", !!props.item[k], value)
                if (!areValuesTheSame(!!props.item[k], value, field.type)) {
                    changed_values[k] = value
                }
            }

            if (!areValuesTheSame(props.item[k], value, field.type)) {
                changed_values[k] = value
            }

        })

        let has_changed = Object.keys(changed_values).length > 0 
        if (!has_changed) {
            has_changed = images.findIndex(f => f.markToDelete) >= 0
        }
        if (!has_changed) {
            has_changed = files.length > 0
        }
        return has_changed
    }



    const ValidateForm = () => {
        // check if required fields are populated
        let not_populated = []
        let theErrors = {}
        // let continue_if_no_errors = true
        // reset dropdown border colors back to normal
        // let bcolors = reactSelectBorderColor
        // Object.keys(bcolors).forEach(k => bcolors[k] = normalBorderColor)
        // console.log('bcolors', bcolors)
        // setReactSelectBorderColor(bcolors)

        // create array of required fields
        const required = fields.filter(f => !!f.required && ((!!f.admin_only && props.mode === "admin") ||  !!!f.admin_only ))
        // console.log("required fields", required)
        required.forEach(field => {
            if (!!field) {
                const value = field.type === 'dictionary' ? dropdowns.find(d => d.name === field.name).option.value : inputRefs.current[field.name].value
                if (field.type === 'dictionary' && !!value) {
                    // verify that value is one of the allowed values
                    const allowed_values = getSelectOptions(field)
                    // console.log("formValidation - field, allowed values", field, allowed_values)
                    if (allowed_values.findIndex(av => av.value === value) < 0) {
                        not_populated.push(inputRefs.current[field.name])
                        theErrors[field.name] = `${field.display_name} is required`
                        setReactSelectBorderColor({...reactSelectBorderColor, [field.name] : errorBorderColor})
                    }
                } else if (!!!value) {
                    // no value - add to the list of fields with error
                    not_populated.push(inputRefs.current[field.name])
                    // theErrors.push(`${field.display_name} is required`)
                    theErrors[field.name] = `${field.display_name} is required`
                    // if it's dropdown - set border color
                    if (field.type === 'dictionary') {
                        setReactSelectBorderColor({...reactSelectBorderColor, [field.name] : errorBorderColor})
                    }
                    
                }

            }
        })


        // create array of required group numbers
        let required_groups = fields.filter(f => !!f.required_group).sort((a,b) => a.required_group > b.required_group ? 1 : -1).map(g => g.required_group)
        // make it unique (i.e. one number per group)
        required_groups = [...new Set(required_groups)]

        required_groups.forEach(grp_id => {
            const groupped_fields = fields.filter(f => f.required_group === grp_id)

            if (groupped_fields.length > 0) {
                let group_values = 0
                groupped_fields.forEach(gf => {
                    const value = gf.type === 'dictionary' ? dropdowns.find(d => d.name === gf.name).option.value : inputRefs.current[gf.name].value
                    if (!!value) {
                        group_values += 1
                    }
                })
                if (group_values === 0) {
                    // add alll fields from the group
                    const labels = []
                    groupped_fields.forEach(gf => {
                        not_populated.push(inputRefs.current[gf.name])
                        labels.push(gf.display_name)
                        
                    })
                    // theErrors.push(`At least one of the fields ${labels.join(', ')} is required`)
                    groupped_fields.forEach(gf => theErrors[gf.name] = `At least on of the ${labels.join(', ').replace(/,(?=[^,]*$)/, " or")} fields is required`)
                }
            }

        })


        // special processing request_onsite_encryption_validation field
        // if selected device type has flag requires_image = true then either user has to upload images or select equest Onsite Encryption Verification checkbox
        const dev_type_field = fields.find(f => f.name === 'device_type')
        const dev_type_value = dropdowns.find(d => d.name === dev_type_field.name).option.value
        
        if (!!dev_type_value) {
            const requires_image = dictCtx.dict_device_type
                .find(dt => dt.system_name === dev_type_field.dictionary && dt.dictionary_value === dev_type_value)?.requires_image
            if (!!requires_image) {
                const request_onsite_encryption_validation = inputRefs.current[reqOnsiteValidation].checked
                //if requires on-site validation not checked - see if there are fresh images
                let ok = 0;
                const images_to_keep = images.filter(img => !!img.markToDelete === false)
                if (images_to_keep.length > 0) {
                    // check if there images dated this year
                    const today_year = new Date().getFullYear()
                    images_to_keep.forEach(img => {
                        const img_date = new Date(img.updated_at)
                        // console.log("img_date", img_date)
                        const img_year = img_date.getFullYear()
                        if (img_year === today_year) {
                            ok++;
                        }
                    })
                } 
                if (!request_onsite_encryption_validation) {
                    if (ok + files.length <= 0) {
                        // there are no images from this year
                        not_populated.push(reqOnsiteValidation)
                        theErrors[reqOnsiteValidation] = `Selected ${dev_type_field.display_name} (${dev_type_value}) requires to upload images verifying encryption or request on-site encryption verification.`
                    }
                } else {
                    // requires on-site validation is checked - if there are images then give a warning
                    if (ok + files.length > 0) {
                        const message = ok + files.length > 1 ? `There are images attached, so the Request On-site Encryption Validation is unnecessary.`:'There is an image attached, so the Request On-site Encryption Validation is unnecessary.'
                        not_populated.push(reqOnsiteValidation)
                        theErrors[reqOnsiteValidation] = message
                    }
                }
                
            } 
        }

        // console.log("not_populated", not_populated)
        // console.log("errors", theErrors)
        setErrors(theErrors)
        // console.log("continue_if_no_errors", continue_if_no_errors)
        return {fields: not_populated, messages: theErrors}



    }



    const saveClick = () => {

        const validationResult = ValidateForm()
        // console.log("validationResult", validationResult)
        // console.log("validationResult", validationResult)
        if (validationResult.fields.length > 0) {
            // some required fields miss values
            // validationResult.messages.forEach(msg => console.log(msg))
            // Object.keys(validationResult.messages).forEach(k => console.log(validationResult.messages[k]))

            setConfirmDialogParams({
                show: true,
                text: ['Errors found during form validation.', 'Please correct errors (fields shown in red) and then click Save Changes button again. You may need to scroll up or down to see all errors.'],
                textClass: 'confirmation-text',
                prompt: 'Errors Found During Form Validation', 
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Validation Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })


            return
        }


        // Access the input values using the refs, except of selects - their values are in dropdowns state
        const inventory_item = {}
        Object.keys(inputRefs.current).forEach(k => {
            // if updating existing item, include only properties that changed

            // for dictionary values (SELECT) get value from the state
            const field = fields.find(f => f.name === k)
            const value = field.type === 'dictionary' ? dropdowns.find(d => d.name === k).option.value : (field.type === 'checkbox' ? inputRefs.current[k].checked : inputRefs.current[k].value)

            if (!!props.item.id) {
                // updatime existing data
                // if ((!!props.item[k] !== !!value) && props.item[k] != value) {
                //     inventory_item[k] = value
                // }
                if (!areValuesTheSame(props.item[k], value, field.type)) {
                    inventory_item[k] = value
                }
            } else {
                // creating new
                const field = fields.find(f => f.name === k)
                
                if (field.type === 'number') {
                    inventory_item[k] = inputRefs.current[k].value.length > 0 ? inputRefs.current[k].value : 0
                } else if (field.type === 'datetime-local' || field.type === 'date') {
                    inventory_item[k] = inputRefs.current[k].value.length > 0 ? formatDateTime(inputRefs.current[k].value) : null
                } else if (field.type === 'dictionary') {
                    inventory_item[k] = value
                } else if (field.type === 'checkbox') {
                    inventory_item[k] = inputRefs.current[k]?.checked ? true: false
                }else {
                    inventory_item[k] = inputRefs.current[k]?.value
                }
            }

            // some fields may not be shown on the screen (for example, is_lab - depends on lab_name)
            if (field.type === 'dictionary' && !!field.dependant) {
                // find depended field
                const field2 = fields.find(f => f.name === field.dependant)
                if (field2.type === 'checkbox' && !areValuesTheSame(props.item[k], !!value, field2.type)) {
                    inventory_item[field2.name] = !!value
                }

            }
            
        })

        



        // console.log("inventory_item before POST",inventory_item)
        
        if (!!props.item.id) {
            trackPromise( updateInventoryItem(inventory_item, props.item.id) )
        } else {
            trackPromise( createInventoryItem(inventory_item) )
        }
        
        
    }



    // populate options for select - from a dictionary
    const getSelectOptions = (field) => {
        const field_dict = dictCtx[`dict_${field.dictionary.toLowerCase()}`]

        // console.log("getSelectOptions - field, field_dict", field, field_dict)

        if (!!field.depends_on && field.type==='dictionary') {
            // options of this field depend on the value of another field - filter options accordingly
            // 1. find value of "parent" field in dropdowns
            const parent = dropdowns.find(d => d.name === field.depends_on)
            if (!!parent) {
                return field_dict.filter(fd => fd.dictionary_type === parent.option.value).map(de => {
                    return {
                        label: de.dictionary_detail,
                        value: !!field.value_field ? de[field.value_field]: de.dictionary_value, 
                    }
                })
            }
        } else if (!!field.depends_on && field.type==='checkbox') {
            // nothig here - just a placeholder for possible extra processing of is_lab field

        } else {
            // doesn't depend on anything - no need to filter dictionary values
            return field_dict.map(de => {
                return {
                    label: de.dictionary_detail,
                    value: !!field.value_field ? de[field.value_field]: de.dictionary_value, 
                }
            })
        }

    }
    



    const onClose = () => {
        // if form values were changed - show dialog
        if (didFormValuesChange()) {
            setConfirmDialogParams({
                show: true,
                text: ["You didn't save changes. If you close this item unsaved changes will be lost.", 'Do you really want to close it?'],
                textClass: 'confirmation-text',
                prompt_class: 'alert-prompt-black',
                cancel_button_text: 'Go back',
                confirm_button_text: 'Close',
                confirm_button_variant: 'danger',
                onClose: (result) => closeConfirmDialog(result),
                title: 'Please Confirm',
                title_class: 'alert-title',
                icon: <BsFillSignStopFill />,
                // showConfirm: true,
                confirm_only: false,
            })
            // setConfirmOnly(false)
            // setShowConfirm(true)
        } else {
            props.onClose(true)
        }
    }


    const closeConfirmDialog = (result) => {
        console.log("closeConfirmDialog - setShowConfirm(false)")
        // setConfirmDialogParams({...confirmDialogParams, showConfirm: false})
        setConfirmDialogParams({show: false})
        // setShowConfirm(false)
        if (result === 'confirm') {
            props.onClose(true)
        }
    }



    const deleteItemClick = () => {
        setConfirmDialogParams({
            show: true,
            text: ["Are you sure you want to delete this Inventory Item?", "If you proceed the item will be deleted permanently."],
            textClass: 'confirmation-text',
            prompt_class: 'alert-prompt-black',
            cancel_button_text: 'Cancel',
            confirm_button_text: 'Delete',
            confirm_button_variant: 'danger',
            onClose: (result) => confirmedDelete(result),
            title: 'Please Confirm',
            title_class: styles['alert-title'],
            icon: <BsFillSignStopFill />,
            // showConfirm: true,
            confirm_only: false,
        })
        // setConfirmOnly(false)
        // setShowConfirm(true)
    }


    const confirmedDelete = (result) => {
        // console.log("Confirm Delete - setShowConfirm(false)")
        setConfirmDialogParams({show: false})
        // setShowConfirm(false)
        if (result === 'confirm') {

            props.onDelete()
        }
    }



    const adjustTableHeight = () => {
        // calculate size of the table
        const html = document.getElementsByTagName("html");
        if (!!html) {
            // console.log("html", html)
            const htmlHeight = html[0].clientHeight;

            // const tbl = document.getElementById('inventory_container');
            const tbl = scrollable.current;
            // console.log("scrollable", tbl)
            if (!!tbl) {
                const rect = tbl.getBoundingClientRect()
                // console.log("Scrollable position", rect )

                // calculate height
                const tblHeight = htmlHeight - rect.top - 100;
                // console.log("Scrollable new height", tblHeight )
                tbl.style.height = `${tblHeight}px`
            }

        }
    }

    // format date to YYYY-mm-DDTHH:MM
    const formatDateTime = (datetime) => {
        // console.log("formatDateTime", datetime)

        if (!!datetime) {
            return moment.utc(datetime).startOf('minute').format('YYYY-MM-DDTHH:mm')
        } else {
            return ""
        }

    }


    



    const addImagesToInventory = (close_form) => {
        const uploadImages = async (fdata) => {
            await fetch(uploadImageURL(item.id), {
                method: 'POST',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    Accept: 'application/json'
                },
                body: fdata
            })
            .then((response) => response.json())
            .then(data => {
                // console.log("inventory images added", data)

                // refresh images
                // getInventoryImages(item.id)

                if (!!close_form) {
                    // props.onClose(true)
                }
                    
            })
            .catch(e => {
                console.log("error uploading image", e)
                setConfirmDialogParams({
                    show: true,
                    text: ['Please try again', 'If the error persists please contact Support'],
                    textClass: 'confirmation-text',
                    prompt: 'Unexpected error happened while trying to add an image to the item', 
                    prompt_class: 'alert-prompt-red',
                    cancel_button_text: null,
                    confirm_button_text: 'OK',
                    confirm_button_variant: 'primary',
                    onClose: (result) => setConfirmDialogParams({show:false}),
                    title: 'Error',
                    title_class: 'alert-title',
                    icon: <BsExclamationCircle />,
                    confirm_only: true,
                })
            })
        }

        // const chosenFiles = Array.prototype.slice.call(e.target.files);

        // if existing inventory item - upload images
        // if new item then show previews
        if (!!item.id) {
            const fdata = new FormData()
            if (!!files && files.length > 0) {
                files.forEach((val, index) => {
                    fdata.append("files", files[index]);
                })
            }
            trackPromise(
                uploadImages(fdata)
            )
            
        }   
    }




    // const addInventoryImages_old = (e) => {
    //     const uploadImages = async (fdata) => {
    //         await fetch(uploadImageURL(item.id), {
    //             method: 'POST',
    //             headers: {
    //                 Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
    //                 Accept: 'application/json'
    //                 // 'Content-Type': 'multipart/form-data'
    //             },
    //             body: fdata
    //         })
    //         .then((response) => response.json())
    //         .then(data => {
    //             console.log("inventory images added", data)

    //             // refresh images
    //             getInventoryImages(item.id)


    //             // setFiles([])
    //             // close the form and refresh item list
    //             // props.onClose(true)
    //         })
    //         .catch(e => console.log("error saving  item", e))
    //     }

    //     const chosenFiles = Array.prototype.slice.call(e.target.files);

    //     // if existing inventory item - upload images
    //     // if new item then show previews
    //     if (!!item.id) {
    //         const fdata = new FormData()
    //         if (!!chosenFiles && chosenFiles.length > 0) {
    //             chosenFiles.forEach((val, index) => {
    //                 fdata.append("files", chosenFiles[index]);
    //             })
    //         }
    //         uploadImages(fdata)
    //     }   
    // }


    const addNewImageFiles = (new_image_files) => {
        const file_list = [...files]
        new_image_files.forEach(f => file_list.push(f))
        // file_list.push(new_image_file)

        // console.log("Image(s) added - files", file_list)
        setFiles([...file_list])
    }


    const onRemoveImageFiles = (images_files_to_remove) => {
        let file_list = [...files]
        images_files_to_remove.forEach(remove => {
            file_list = file_list.filter(afile => afile !== remove)
        })
        // file_list.push(new_image_file)

        // console.log("Image removed - files", file_list)
        setFiles([...file_list])
    }



    const toggleDelete = (images_to_delete) => {
        let inventory_images = images
        images_to_delete.forEach(img_dlt => {
            const indx = inventory_images.findIndex(img => img.id === img_dlt.id)
            if (indx >= 0) {
                // toggle to delete status
                inventory_images[indx].markToDelete = !!!inventory_images[indx]?.markToDelete
            }
        })
        setImages([...inventory_images])

    }


    const getInventoryImages = async (inventory_id) => {
        const url = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}inventory_images/invntry/${inventory_id}` : `${process.env.REACT_APP_API_URL_PROD}inventory_images/invntry/${inventory_id}`
        await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`
            }
        })
        .then((response) => response.json())
        .then(data => {
            // console.log("inventory images", data)
            if (!!data && Array.isArray(data)) {
                setImages(data)
            } else {
                // no images - returned value is an object {detail: <message>}
                setImages([])
            }
        })
        .catch(e => {
            console.log("error getting the item's images", e)
            setConfirmDialogParams({
                show: true,
                text: ['Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                prompt: "Unexpected error happened while trying to get the item images",
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        })
    }





    const getInventoryItem = async (id) => {
        const url = process.env.REACT_APP_MODE === "TEST" ? `${process.env.REACT_APP_API_URL_TEST}inventories/${id}` : `${process.env.REACT_APP_API_URL_PROD}inventories/${id}`
        await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`
            }
        })
        .then((response) => response.json())
        .then(data => {
            // console.log("inventory item", data)
            if (!!data) {
                setItem(data)
                setDeviceChanged(false)
                getInventoryRecerts(id)
                getInventoryImages(id)
            }
        })
        .catch(e => {
            console.log("error getting selected item", e)
            setConfirmDialogParams({
                show: true,
                text: ['Please try again', 'If the error persists please contact Support'],
                textClass: 'confirmation-text',
                prompt: 'Unexpected error happened while trying to get the item', 
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })
        })
    }




    const showHideAuditClick = () => {

        // it's toggle button - hide if shown
        if (audits.length > 0) {
            setAudits([])
            return
        }
        // get audit records
        const getAudit = async (inventory_id) => {
            let statusCode = ''
            await fetch(getAuditURL(inventory_id), {
                method: 'GET',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    Accept: 'application/json'
                },
            })
            .then((response) => {
                statusCode = response.status
                return response.json()
            })
            .then(data => {
                // console.log("audit data, status", data, statusCode)
                if (statusCode === 200 && Array.isArray(data)) {
                    setAudits(data.sort((a,b) => new Date(b?.updated_at) - new Date(a?.updated_at)))

                    // scroll audit into view
                    setTimeout(() => { 
                        const aud = document.getElementsByClassName('audit-recs')
                        // console.log("Audit element", aud)
                        if (!!aud) {
                            aud[0].scrollIntoView({
                                behavior: 'smooth', // Defines the transition animation. It can be "auto" (default), "instant" or "smooth".
                                block: 'start', // Defines vertical alignment. It can be "start", "center", "end", or "nearest".
                                inline: 'nearest' // Defines horizontal alignment. It can be "start", "center", "end", or "nearest".
                              });
                        } 
                    }, 200);
                } else { 
                    let messages = ["Unknown Error"]
                    if (statusCode === 404 || statusCode === 200) {
                        messages = ["No Audit Records found"]
                        if (!!data.detail && typeof(data.detail) === 'string') {
                            messages = [data.detail]
                        }
                    } else {
                        messages = ["Unknown error.", "Please try again", "If you keep getting these errors please contact support"]
                    }
                    setConfirmDialogParams({
                        show: true,
                        text: messages,
                        textClass: 'confirmation-text',
                        prompt_class: 'alert-prompt-red',
                        cancel_button_text: null,
                        confirm_button_text: 'OK',
                        confirm_button_variant: 'primary',
                        onClose: (result) => {
                            setConfirmDialogParams({show: false})
                        },
                        title: null, //'Please Confirm',
                        // title_class: styles['alert-title'],
                        icon: <BsInfoCircle />,
                        // showConfirm: true,
                        confirm_only: true,
                    })
                    // setConfirmOnly(true)
                }

                    
                    
                // close the form and refresh item list
                // props.onClose(true)
            })
            .catch(e => console.log("error saving  item", e))
        }

        if (!!props.item.id) {
            trackPromise(
                getAudit(props.item.id)
                ,'no_close'
            )
        }
        
    }


    

    const getAttestationStatus = async (item_id) => {
        const url = `${baseURL}inventory_attests/invntry/${item_id}`;
        await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
            },
        })
        .then((response) => response.json())
        .then(data => {
            const currentYear = new Date().getFullYear()
            // if we have attestation data from this year
            if ((data !== null && !!data.id && moment.utc(data.updated_at).toDate().getFullYear() === currentYear) || 
                // or no this year attestation but item created this year AND by the user who is the owner of the item
                (!!!data.id && moment.utc(props.item.created_at).toDate().getFullYear() === currentYear && 
                    (((props.mode === "user" && props.item.added_by_userid === userCtx.id) || (props.mode === "admin" && props.item.employee_acct.toLowerCase() === props.item.added_by_employee_acct.toLowerCase())  )))) {
                // console.log("Return from get item attestation", data)
                const attestationText = data !== null && !!data.id && moment.utc(data.updated_at).toDate().getFullYear() === currentYear ? 
                    `Attested on ${moment.utc(data.updated_at).format('MM/DD/YYYY')}.` : 'New record - Attestation is not required.'
                setAttestationStatus({
                    ...data, 
                    is_attested: true, 
                    text: attestationText,
                    style: 'item-attested', 
                    text_style: 'attested-text', 
                    button: 'Attest', 
                    disabled: true
                })
            } else {
                // no attestation or not attested this year: return looks like {detail: <message>}
                // if record created this year and by the same employee who the record belongs to - no attestation needed
                let text = ''
                if (moment.utc(props.item.created_at).toDate().getFullYear() === currentYear && props.item.employee_acct.toLowerCase() === props.item.added_by_employee_acct.toLowerCase()) {
                    text = 'New record - Attestation is not required.'
                } else {
                    text = props.mode === "admin" ? 'Device is not attested.' :  'Please attest that the device information is accurate.';
                }
                
                setAttestationStatus({is_attested: false, text: text, style: 'item-not-attested', text_style: 'not-attested-text', button: 'Attest', disabled: false})
            }

        })
        .catch(e => {
            console.log("error getting attestion", e)
            setAttestationStatus(null)
        })
    }





    useEffect(() => {
        // console.log("Inventory Form props", props)
        if (!!props.item.id) {
            getInventoryItem(props.item.id)
            // get user attestation record
            // 4/17/2026 - they don't need attestation anymore. Instead of attestation check the device status and if not set, user should update it
            // the point if this is just to set the style
            // getAttestationStatus(props.item.id)
            if (!props.item.device_status) {
              setAttestationStatus({
                ...attestationStatus, 
                is_attested: false, 
                text: 'Please update device status and save changes!',
                style: 'item-not-attested', 
                text_style: 'not-attested-text', 
                // button: null, 
                // disabled: true
              }) 
            } 
        } else {
            setItem(props.item)
            setDeviceChanged(false)
        }

        
        
        
        if (dropdowns.length === 0) {
            let initVals = []
            let dropdownBorders = {}
            fields.filter(f => f.type === 'dictionary').forEach(f => {
                const val = !!props.item.id ? props.item[f.name] : f.null_value

                
                const dict_entry = dictCtx[`dict_${f.dictionary.toLowerCase()}`].find(de => de[f.value_field] === val)
                // console.log("dict_entry", dict_entry)
                const label = !!dict_entry ? dict_entry.dictionary_detail : ''
                // console.log("setting up initial value for", f.name, val)
                initVals.push({name: f.name, option: {label: label, value: val}})
                
                // set default border style for each dropdown - we need to be able to change it when there is an error on validation
                dropdownBorders[f.name] = normalBorderColor
                
            })
            // console.log("Initialized dropdowns",initVals)
            setDropdowns([...initVals])
            setReactSelectBorderColor(dropdownBorders)
        }

        // initial enable/disable checkbox for Request On-site Ecryption Validation
        // it depends on the value of device type dropdown


    },[props.item, props.mode])



    useEffect(() => {
        const handleWindowResize = () => {
            adjustTableHeight();
        };
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
    }, []);


    useLayoutEffect(() => {
        adjustTableHeight();
    })

 

    const select_styles = (name) => {
        return {
        control: (base) => {
            // console.log("control base", base)
            return {
                ...base,
                minHeight: 28,
                width:'75%',
                fontSize: '1.0em',
                // paddingTop: 0,
                paddingBottom: 0,
                paddingTop: 0,
                marginBottom: 0,
                marginTop: 0,

                // border: 'solid red 1px',
                borderColor: reactSelectBorderColor[name]

            }
        },
        dropdownIndicator: (base) => ({
          ...base,
          paddingTop: 0,
          paddingBottom: 0,
          height: '1.0em',
        }),
        clearIndicator: (base) => ({
          ...base,
          paddingTop: 0,
          paddingBottom: 0,
          marginBottom: 0,
          marginTop: 0,
          height: '1.0em',
          fontSize: '1.0em',
        }),
        input: styles => {
            // console.log("input styles", styles)
            return {
              ...styles,
              height: '1.0em',
              fontSize: '0.8em',
            //   paddingBottom: 0,
            //   paddingLeft: 0,
            //   margin: '0px 0px 0px 0px',
        }},
        // menu: (base) => ({
        //     ...base,
        //     height: '1.0em',
        // }),
        // menuList: (base) => ({
        //     ...base,
        //     // fontSize: '0,5em',
        // }),
        menu: (base) => ({
            ...base,
            fontSize: '0.9em',
        }),
        spacing: (base) => ({
            ...base.spacing,
            // controlHeight: 20,
            baseUnit: 1
        })

    }}

    const customThemeFn = (theme) => { 
        console.log("Default theme", theme)
        return {
        ...theme,
        spacing: {
          ...theme.spacing,
          controlHeight: 20,
          baseUnit: 1
        }}
        // control: (provided) => ({
        //     ...provided,
        //     width: 200, // Set the desired width here
        //   }),
        // clearIndicator: (base) => ({
        //     ...base,
        //     padding: `${(28 - 20 - 1 - 1) / 2}px`,
        // }),
        // menu: (base) => ({
        //     ...base,
        //     height: '1.0em',
        // })
    }



    const customSelect = (props) => {
        return (
            <Select {...props} />
        )
    }

    const customInput = (props) => {
        return (
            <input {...props} />
        )
    }



    const resetFieldErrors = (field) => {
        const newErrors = {...errors}
        newErrors[field.name] = null
        // setErrors({...errors, [field.name]:null})
        // if the field is part of required group, reset errors for other fields in the group
        if (!!field.required_group) {
            const group_fields = fields.filter(gf => gf.required_group === field.required_group && gf.name !== field.name)
            if (group_fields.length > 0) {
                // group_fields.forEach(gf => setErrors({...errors, [gf.name]:null}))
                group_fields.forEach(gf => newErrors[gf.name] = null)
            }
        }

        setErrors({...newErrors})
    }



    const attestDevice = () => {

        const sendAttestation = async () => {
            const url = `${baseURL}inventory_attests/`;
            const body = {
                added_by_userid: userCtx.id,
                inventory_id: props.item.id,
                noinventory_id: null,
                record_added_year: '' + new Date().getFullYear(),
                // comments: "string"
            }
            await fetch(url, {
                method: 'POST',
                headers: {
                    Authorization: `${userCtx.token_type} ${userCtx.jwt}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
            .then((response) => {
                // console.log("sendAttestation response", response.status)
                if (response.ok) {
                    return response.json()
                } else if (response.status === 404) {
                    // not attested item
                    console.log("No attestation found")
                    // setAttestationStatus({text: 'Please attest that the device information is accurate', style: 'item-not-attested', button: 'Attest', disabled: false})
                    return null
                }
            })
            .then(data => {
                if (data !== null) {
                    // console.log("Return from sendAttestation", data)
                    // setAttestationStatus({...data, text: 'Attested', style: 'item-attested', button: 'Attest', disabled: true})
                }

            })
            .catch(e => {
                console.log("error getting attestion", e)
                setAttestationStatus(null)
            })
        }

        // validate record before attestation

        const validationResult = ValidateForm()
        // console.log("validationResult", validationResult)
        // console.log("validationResult", validationResult)
        if (validationResult.fields.length > 0) {
            // some required fields miss values
            // validationResult.messages.forEach(msg => console.log(msg))
            // Object.keys(validationResult.messages).forEach(k => console.log(validationResult.messages[k]))

            setConfirmDialogParams({
                show: true,
                text: ['Errors found during form validation.', 'Please correct errors (fields shown in red) and save changes before attesting the device. You may need to scroll up or down to see all errors.'],
                textClass: 'confirmation-text',
                prompt: 'Errors Found During Form Validation', 
                prompt_class: 'alert-prompt-red',
                cancel_button_text: null,
                confirm_button_text: 'OK',
                confirm_button_variant: 'primary',
                onClose: (result) => setConfirmDialogParams({show:false}),
                title: 'Validation Error',
                title_class: 'alert-title',
                icon: <BsExclamationCircle />,
                confirm_only: true,
            })


            return
        }


        trackPromise(
            sendAttestation()
        )
    }


    // render field. f = field definition
    const renderField = (f) => {
        const editable_admin_only = (props.mode === 'admin' && f.read_only === false) || !(props.mode !== "admin" && (f.readonly_if_not_admin || false) === true)
        return (
            <div key={f.name} >
                {(f.type === 'datetime-local' || f.type === 'date') &&
                <>
                    <input id={f.name} type={f.type} 
                        defaultValue={moment.utc(item[f.name]).startOf('minute').format('YYYY-MM-DDTHH:mm') ?? ''}
                        onChange={e => {
                            resetFieldErrors(f)
                            setItem({...item, [f.name]: e.target.value ?? ''})
                            setDeviceChanged(true);
                        }}
                        ref={(el) => inputRefs.current[f.name] = el}
                    />
                    {!!errors[f.name] ?
                        <div className={styles['invalid-feedback-override']}>
                            <BsExclamationCircle /> {errors[f.name]}
                        </div>
                        :
                        <div className={styles['form-field-info']}>
                            {f.info ?? ''}
                        </div>
                    }
                </>
                }

                {(f.type === 'text' || f.type === 'number') &&
                <>
                    <input 
                        id={f.name} 
                        type={f.type} 
                        hidden={!!f.admin_only && props.mode !== "admin"}
                        defaultValue={item[f.name] ?? ''}
                        ref={(el) => inputRefs.current[f.name] = el}
                        onChange={e => {
                            resetFieldErrors(f)
                            setItem({...item, [f.name]: e.target.value ?? ''})
                            setDeviceChanged(true);
                        }}
                        readOnly={props.mode !== "admin" && f.readonly_if_not_admin  === true}
                        className={`${!!errors[f.name] ? styles.err : ''} ${!userCtx.is_super_user && (f.readonly_if_not_admin || false) === true ? styles.readonly : ''}`}
                    />
                    {!!errors[f.name] ?
                        <div className={styles['invalid-feedback-override']}>
                            <BsExclamationCircle /> {errors[f.name]}
                        </div>
                        :
                        <div className={styles['form-field-info']}>
                            {f.info ?? ''}
                        </div>
                    }
                </>
                }


                {(f.type === 'textarea') &&
                <>
                <Row>
                    <Col sm={12}>
                    <textarea 
                        id={f.name} 
                        type={f.type} 
                        defaultValue={item[f.name] ?? ''}
                        ref={(el) => inputRefs.current[f.name] = el}
                        onChange={e => {
                            resetFieldErrors(f)
                            setItem({...item, [f.name]: e.target.value ?? ''})
                            setDeviceChanged(true);
                        }}
                        readOnly={!userCtx.is_super_user && (f.readonly_if_not_admin || false) === true}
                        className={`${styles.textarea} ${!!errors[f.name] ? styles.err : ''} ${!userCtx.is_super_user && (f.readonly_if_not_admin || false) === true ? styles.readonly : ''}`}
                    />
                    {!!errors[f.name] ?
                        <div className={styles['invalid-feedback-override']}>
                            <BsExclamationCircle /> {errors[f.name]}
                        </div>
                        :
                        <div className={styles['form-field-info']}>
                            {f.info ?? ''}
                            {!!f.mailto && !!f.mailto_text &&
                                <a href={`mailto:${f.mailto}`}>{f.mailto_text}</a>
                            }
                        </div>
                    }
                    </Col>
                    </Row>
                </>
                }


                {(f.type === 'checkbox') &&
                <>
                    <Form.Check // prettier-ignore
                        id={f.name}
                        defaultChecked={!!item[f.name]}
                        ref={(el) => inputRefs.current[f.name] = el }
                        onChange={e => {
                            resetFieldErrors(f)
                            setItem({...item, [f.name]: !!e.target.checked ? e.target.checked : false})
                            setDeviceChanged(true);
                        }}
                        isInvalid={!!errors[f.name]}
                        disabled={isRequestOnsiteValidationDisabled()}
                        className={styles[isRequestOnsiteValidationDisabled() ? 'disabled' : 'enabled']}
                    />
                    {!!errors[f.name] ?
                        <div className={styles['invalid-feedback-override']}>
                            <BsExclamationCircle /> {errors[f.name]}
                        </div>
                        :
                        <div className={styles['form-field-info']}>
                            {f.info ?? ''}
                        </div>
                    }
                </>
                }


                {f.type === 'dictionary' && dropdowns.length > 0 &&
                    <>
                        {editable_admin_only ? 
                        <Select
                            styles={select_styles(f.name)}
                            isClearable={true}
                            menuPortalTarget={document.body}
                            isSearchable={true}
                            name={f.name}
                            options={getSelectOptions(f)}
                            ref={(el) => inputRefs.current[f.name] = el}
                            onChange={(e) => onSelect(f.name, e)}
                            value={dropdowns.find(d=>d.name===f.name).option || ''}
                        />
                        :
                        <Select
                            styles={select_styles(f.name)}
                            isClearable={false}
                            // menuPortalTarget={document.body}
                            name={f.name}
                            // options={getSelectOptions(f)}
                            // ref={(el) => inputRefs.current[f.name] = el}
                            // onChange={(e) => onSelect(f.name, e)}
                            value={dropdowns.find(d=>d.name===f.name).option || ''}
                            menuIsOpen={false}       // Prevents the options dropdown from opening
                            isSearchable={false}     // Prevents typing inside the input
                            openMenuOnClick={false}  // Prevents opening when clicked
                            openMenuOnFocus={false}  // Prevents opening when focused via keyboard
                        />
                        }
                        {!!errors[f.name] ?
                            <div className={styles['invalid-feedback-override']}>
                                <BsExclamationCircle /> {errors[f.name]}
                            </div>
                            :
                            <div className={styles['form-field-info']}>
                                {f.info ?? ''}
                            </div>
                        }
                    </>
                }
            </div>
        )

    }


    // run ValidateForm after all fields are rendered
    useLayoutEffect(() => {
      if (!!props.item && dropdowns.length > 0 && !initialLoadFinished) {
        const required = fields.filter(f => !!f.required && ((!!f.admin_only && props.mode === "admin") ||  !!!f.admin_only ))
        const reqRefsKeys = Object.keys(inputRefs.current);
        const reqRefs = required.map((req) => inputRefs.current[req.name] ?? null).filter(ref => ref !== null)
        // console.log("required", required)
        // console.log("reqRefs", reqRefs)
        if(reqRefs.length === required.length) {
          // console.log("Validating...")
          // ValidateForm();
          setInitialLoadFinished(true);
        }
          
      }
    })

    useEffect(() => {
      if (initialLoadFinished) {
        // console.log("Validating...")
        ValidateForm();
      }
    }, [initialLoadFinished]);
 

    return (
        <>
            {/* {props.mode === "admin" &&
                <div className={`row mx-5 cert-status`}>
                    <h5 className={styles[recertsStatus.style]}>{recertsStatus.text}</h5>
                </div>
            }

            {dictCtx.dict_attestion_status === 'ON' && 
                <div className={`row mx-5 cert-status`}>
                    <h5 className={styles[attestationStatus?.style]}>{attestationStatus?.text}</h5>
                </div>
            }  */}
            {/* <h6 className='mx-5'>
                {props.mode === "admin" ?
                    <>
                    <span className={styles[recertsStatus.text_style]}>{recertsStatus.text}</span>
                    {dictCtx.dict_attestion_status === 'ON' &&
                        <span className={styles[attestationStatus?.text_style]}> {attestationStatus?.text}</span>
                    }
                    </>
                    :
                    <>
                    {dictCtx.dict_attestion_status === 'ON' &&
                        <span className={styles[attestationStatus?.text_style]}>{attestationStatus?.text}</span>
                    }
                    </>
                }
            </h6> */}

            <div className={`row mx-3 w-100`}>     
                <Col lg={6} md={6} sm={6} xs={7}>
                    {props.mode === "admin" &&
                        <span className={styles[recertsStatus.text_style]}>{recertsStatus.text}</span>
                    }
                    {/* {dictCtx.dict_attestion_status === 'ON' && */}
                        <span className={styles[attestationStatus?.text_style]}> {attestationStatus?.text}</span>
                    {/* } */}
                </Col>
                <Col xl={6} md={6} sm={6} xs={7}>
                    {requiredGroupsNotes.length > 0 &&
                        <ul >
                            {requiredGroupsNotes.map((g,gix) => <li key={gix} className={styles['ul-no-bullets']}><span className={styles['ul-group-id']}>*{g.gid}</span><span className={styles['ul-no-bullets-li']}> - {g.text}</span></li>) }
                        </ul>
                    }
                </Col>
            </div>
           

            <div className={styles.inventory_container} ref={scrollable}>

                <div className={`w-100 row mx-3`}>       
                        {!!item && fields.map(f => {
                            return (
                                f.show && ((!!f.admin_only && props.mode === "admin") || !!!f.admin_only) ?
                                <Col key={f.name} xxl={3} xl={4} lg={6}  xs={12} className={`${styles.handle_overflow} `}>
                                    <div 
                                      // key={f.name} 
                                      >
                                        {(!!f.admin_only && props.mode === "admin" || !!!f.admin_only) && 
                                            <label 
                                                htmlFor={f.name} 
                                                className={styles.field_header}
                                            >
                                               {f.display_name}{!!f.required_group ?<sup className={styles.sup}>*{f.required_group}</sup>:!!f.required ?<sup className={styles.sup}>*</sup>:''}
                                            </label>
                                        }
                                        {renderField(f)}
                                    </div>
                                </Col>
                                :
                                f.show && ((!!f.admin_only && props.mode !== "admin") && !!f.required) ? 
                                <>
                                    {renderField(f)}
                                </>
                                :
                                null
                                
                            )
                        })}

                        {/* {requiredGroupsNotes.length > 0 &&
                            <ul className='mt-5'>
                                {requiredGroupsNotes.map(g => <li className={styles['ul-no-bullets']}><span className={styles['ul-group-id']}>*{g.gid}</span><span className={styles['ul-no-bullets-li']}> - {g.text}</span></li>) }
                            </ul>
                        } */}
                    

                </div>

                <InventoryImages 
                    inventoryItem={item} 
                    images={images} 
                    image_files={files} 
                    onAddImages={addImagesToInventory} 
                    onAddNewImageFiles={addNewImageFiles} 
                    onRemoveImageFiles={onRemoveImageFiles}
                    toggleDelete={toggleDelete}
                />
                {audits.length > 0 &&
                    <AuditList 
                        ref={refAudit}
                        auditItems={audits} 
                        
                    />
                }

                
            </div>

            <Row className='mt-4'>
                {/* <div className='col mt-1 my-1 mx-5 d-flex justify-content-start align-items-start'>
                    <span className={styles.annotation}><span className={styles.required}> *</span> - Required;&nbsp;&nbsp;</span>
                    <span className={styles.annotation}><span className={styles.required}> *&lt;group number&gt;</span> - at least one of the group required.</span>

                </div> */}
                
                <div className='col-2 mx-5 justify-content-start align-items-start'>
                    {/* {!(!!!props.item.id || dictCtx.dict_attestion_status === 'OFF' || attestationStatus?.is_attested === true) &&
                    <Button size='sm' 
                        variant="danger" 
                        className='mx-2 font08' 
                        onClick={attestDevice} 
                    >
                        Attest Device
                    </Button>
                    } */}
                </div>
                
                
                <div className='col-8 mx-5 d-flex justify-content-end align-items-start'>
                    {/* {!(!!!props.item.id || dictCtx.dict_attestion_status === 'OFF' || attestationStatus?.is_attested === true) &&
                        <Button size='sm' 
                            variant="danger" 
                            className='mx-2 font08' 
                            onClick={attestDevice} 
                        >
                            Attest Device
                        </Button>
                    } */}

                    {props.mode === "admin" &&
                    <>
                        <Button size='sm' variant="outline-primary" className='mx-2 font08' onClick={showHideAuditClick} disabled={!!!props.item.id}>
                            <span className='mx-2'>{audits.length > 0 ? 'Hide Audit Records' : 'Show Audit Records'}</span>
                        </Button>
                        <Button size='sm' variant="outline-danger" className='mx-2 font08' onClick={deleteItemClick} disabled={!!!props.item.id}>
                            <span className='mx-2'>Delete Device</span>
                        </Button>
                    </>
                    }
                    
                    {props.mode === "admin" &&
                        <Button size='sm' variant="outline-primary" className='mx-2 font08' onClick={certifyItemClick} disabled={!!!props.item.id || recertsStatus.disabled}>
                            <span className='mx-2'>{recertsStatus.button}</span>
                        </Button>
                    }

                    <Button size='sm' variant="outline-primary" className='mx-2 font08' onClick={saveClick}>
                        <span className='mx-2'>Save Changes</span>
                    </Button>

                    <Button size='sm' variant="outline-primary" className='mx-2 font08' onClick={onClose}>
                        <span className='mx-2'>Close</span>
                    </Button>

                </div>

            </Row>
            
            

            {confirmDialogParams.show &&
                <ConfirmDialog 
                    show={confirmDialogParams.show}
                    iconColor='red'
                    iconSize='2rem'

                    // icon={<BsFillSignStopFill />}
                    icon={confirmDialogParams.icon}
                    title={confirmDialogParams.title}
                    // title_class={styles['alert-title']}
                    title_class={confirmDialogParams.title_class}
                    text={confirmDialogParams.text}
                    textClass={confirmDialogParams.textClass}
                    prompt={confirmDialogParams.prompt}
                    prompt_class={confirmDialogParams.prompt_class}
                    cancel_button_text={confirmDialogParams.cancel_button_text}
                    confirm_button_text={confirmDialogParams.confirm_button_text}
                    confirm_button_variant={confirmDialogParams.confirm_button_variant}
                    onClose={confirmDialogParams.onClose}
                    confirm_only={confirmDialogParams.confirm_only}
                />
            }
            
            <LoadingSpinner size='100px' onEndOfPromise={() => props.onClose(true)} />
            {/* <LoadingSpinner size='100px' area="no_close" /> */}
        </>
    )
}

export default InventoryForm
